/**
 * The react-query keys for the triage endpoints, and NOTHING else.
 *
 * 🚨 Their own module because of what importing them used to drag along. The
 * row-level ✓ on the opener table and the Descalces column needs to
 * invalidate these after a write — and pulling them from `useTriageList` /
 * `useTriageIndex` pulled those whole modules into `EntryTabByPath` and
 * `DescalceCells`, whose tests replace `useTriageIndex` with a one-export
 * `vi.mock`. Four suites stopped COLLECTING (91 tests silently not run, which
 * a green summary hides) because the module graph now wanted exports the
 * double never had.
 *
 * A module with no imports cannot do that to anyone.
 */

/** Root of every `useTriageList` entry — see `triageListKey` for the shape. */
export const TRIAGE_LIST_KEY_ROOT = 'triage-list';

/** The single triage-index entry, shared fleet-wide. */
export const TRIAGE_INDEX_KEY = ['triage-index'] as const;
